import RHFDictionary from '../RHFDictionary';
import { useProductCategory } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'description',
    label: 'Name',
    align: 'left',
    nameLines: 2,
    subNameLines: 1,
    minWidth: 180,
    width: 260,
    maxWidth: 320,
  },
  {
    name: 'parent',
    label: 'Parent',
    align: 'left',
    minWidth: 120,
    width: 160,
    maxWidth: 200,
  },
];

type RHFProductCategoryProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFProductCategory({
  name,
  label = 'Category',
  multiple = false,
  disabled,
  drawerWidth = { xs: '100%', sm: 480 },
}: RHFProductCategoryProps) {
  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useProductCategory}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={{}}
      drawerWidth={drawerWidth}
    />
  );
}
